import React, { useContext, useEffect } from 'react'
import './index.sass';
import { DarkModeContext } from '../../../global/Theme'
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';

// autocapitalize = 0 - none
// autocapitalize = 1 - word

export default function Input({ placeholder, icon, type, handleInputChange, isError, autocapitalize = 0, refer = null, max=1000, value="" }) {
    const { isDark } = useContext(DarkModeContext);
    const dispatch = useDispatch();
    const location = useLocation();

    const showNavbar = () => {
        if(location.pathname == '/editprofile' || location.pathname == '/login' || location.pathname == '/register' || location.pathname == '/editprofile-creator'){
            console.log("i am not gonna show u navbar")
        } else {
            dispatch({ type: "SHOW_NAVBAR" });
        }
    }

    const hideNavbar = () => {
        dispatch({ type: "HIDE_NAVBAR" });
    }
    useEffect(() => {
    }, [isDark])

    return (
        <div className={isDark ? isError != null && isError 
        ? "lover-input-wrapper-dark error-input" : "lover-input-wrapper-dark" 
        : isError != null && isError 
        ? 'lover-input-wrapper error-input' 
        : 'lover-input-wrapper'} >
            <img style={{ marginLeft: '5px' }} src={require(`../../../assets/icons/${icon}`)}></img>
            <textarea 
            ref={refer != null ? refer : null} 
            onChange={handleInputChange} 
            placeholder={placeholder} 
            value={value}
            onBlur={showNavbar} 
            onFocus={hideNavbar} 
            type={type} 
            max={max}
            className={isDark 
            ? autocapitalize == 1 
            ? 'lover-input-widget-dark capitalize' 
            : 'lover-input-widget-dark' 
            : autocapitalize == 1 
            ? 'lover-input-widget capitalize' 
            : 'lover-input-widget'} />
        </div>
    )
}
